<template id="JobStatusCard">
    <b-card style="max-width: 20rem;" :title="JobDescription">
        <!-- Errori -->
        <b-alert v-if="errors && errors.length" variant="danger" show dismissible>
            <ul>
                <li v-for="error of errors" :key="error.id">
                    Errore : {{error.message}}
                </li>
            </ul>
        </b-alert>
  
        <div v-if="JobStatus">

            <div v-if="JobStatus.message" class="mb-1">
                <div :style="messageStyle">{{ JobStatus.message }}</div>
                <a v-if="messageIsLong" href="#" class="small" @click.prevent="messageExpanded = !messageExpanded">
                    {{ messageExpanded ? 'Mostra meno' : 'Mostra tutto' }}
                </a>
            </div>
            {{GetJobStatusDescription(JobStatus.fkstatus)}}
            
            
            <div v-if="JobStatus.fkstatus == 140">
                <span>Answer:</span>                
                <b-button variant="outline-success" @click="SetAnswer(JobStatus.id,true)">Yes</b-button>
                <b-button variant="outline-danger" @click="SetAnswer(JobStatus.id,false)">No</b-button>                
            </div>
            <div v-else>
                <b-progress :value="100" :variant="GetProgresscolor(JobStatus.fkstatus)" striped :animated="JobStatus.fkstatus==150"></b-progress>
            </div>

            <div v-if="JobStatus.fkstatus >= 200 && JobStatus.fkfilestore" class="mt-2">
                <b-button variant="outline-success" size="sm" :disabled="isDownloading" @click="DownloadFile(JobStatus.id)">
                    <template v-if="isDownloading">
                        <b-spinner small type="grow"></b-spinner> Download in corso…
                    </template>
                    <template v-else>
                        <font-awesome-icon icon="download" /> Scarica file
                    </template>
                </b-button>
                <small v-if="isDownloading" class="text-muted d-block mt-1">
                    Il file può richiedere tempo, puoi continuare a lavorare.
                </small>
            </div>

            <font-awesome-icon size="lg" class="icon_azure" icon="sync-alt" @click="GetJobStatus()" />
        </div>
    </b-card>
</template>

<script>
    import axios from 'axios';
    export default {
        props: {
            rifjob: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                errors: [],
                timer: '',
                JobStatus: {},
                JobDescription: '',
                isDownloading: false,
                messageExpanded: false
            }
        },
        computed: {
            // Il messaggio del job (es. elenco righe scartate) può essere molto lungo:
            // di default lo mostriamo troncato a ~3 righe, con un toggle "Mostra tutto".
            messageIsLong() {
                var m = (this.JobStatus && this.JobStatus.message) ? this.JobStatus.message : '';
                return m.split(/\r?\n/).length > 3 || m.length > 160;
            },
            messageStyle() {
                if (this.messageExpanded || !this.messageIsLong) {
                    return { whiteSpace: 'pre-wrap', fontSize: '0.85rem' };
                }
                return {
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    fontSize: '0.85rem'
                };
            }
        },
        watch: {
            rifjob: {
                immediate: true,
                deep: true,
                handler(newVal) {
                    if (newVal != 0) {
                        console.log('rifjob : ' + newVal);
                        this.GetJobStatus();
                        this.timer = setInterval(this.GetJobStatus, 10000)
                    }
                    else {
                        clearInterval(this.timer);
                    }
                }
            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
            cancelAutoUpdate() { clearInterval(this.timer) },
            GetJobStatus() {                
                console.log('GetJobStatus : ' + this.rifjob);
                let self = this;
                var Link = 'api/_main/SchedulerJob/' + this.rifjob;
                axios.get(Link, this.$store.state.Headers)
                    .then(response => {
                        self.JobStatus = response.data.Result;
                        //self.JobDescription = self.GetTitle(self.JobStatus.fktype, self.JobStatus.fkschedulerjobtemplate);

                        var tTitle = 'N.A';

                        
                        if (Object.prototype.hasOwnProperty.call(self.JobStatus, 'fkschedulerjobtemplate')) {
                            tTitle = this.$store.state.Jobs.find(E => E.id === self.JobStatus.fkschedulerjobtemplate).description;
                        }

                        if (Object.prototype.hasOwnProperty.call(self.JobStatus, 'fkfileloaderlayout')) {
                            tTitle = this.$store.state.FileLoaderLayouts.find(E => E.id === self.JobStatus.fkfileloaderlayout).label;
                        }
                            
                        
                                                
                        self.JobDescription = tTitle;   



                        if (self.JobStatus.fkstatus == 220) {
                            clearInterval(this.timer);
                        }

                        if (self.JobStatus.fkstatus == 250) {
                            clearInterval(this.timer);
                        }

                    }).catch(e => {
                        this.errors.push(e);
                    });
                

            },
            GetJobStatusDescription: function (idjobstatustype) {
                if (idjobstatustype) {
                    var tStatus = this.$store.state.JobStatusTypes.find(E => E.id === idjobstatustype);
                    return tStatus.description;
                }
                else {
                    return '';
                }
            },
            GetProgresscolor: function (idjobstatustype) {
                var tVariant = 'secondary';
                //console.log('idjobstatustype ' + idjobstatustype);

                if (idjobstatustype == 150) {
                    tVariant = 'primary';
                }

                if (idjobstatustype == 220) {
                    tVariant = 'danger';
                }

                if (idjobstatustype == 250) {
                    tVariant = 'success';
                }

                console.log(tVariant);
                return tVariant;
            },
            DownloadFile: function (jobId) {
                if (this.isDownloading) return;
                this.isDownloading = true;
                this.$bvToast.toast('Download avviato. La preparazione del file può richiedere tempo.', {
                    title: 'Download', variant: 'info', autoHideDelay: 4000, appendToast: true
                });
                let config = Object.assign({}, this.$store.state.Headers, { responseType: 'blob' });
                axios.get('files/download/' + jobId, config)
                    .then(response => {
                        const disposition = response.headers['content-disposition'];
                        const fileName = disposition
                            ? (disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/) || [])[1] || 'export'
                            : 'export';
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const a = document.createElement('a');
                        a.href = url;
                        a.setAttribute('download', fileName.replace(/['"]/g, ''));
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                        this.$bvToast.toast('Download completato.', {
                            title: 'Download', variant: 'success', autoHideDelay: 3000, appendToast: true
                        });
                    }).catch(e => {
                        this.errors.push(e);
                        this.$bvToast.toast('Errore durante il download.', {
                            title: 'Download', variant: 'danger', autoHideDelay: 5000, appendToast: true
                        });
                    }).finally(() => {
                        this.isDownloading = false;
                    });
            },
            SetAnswer: function (parId, parAnswer) {
                var Link = parAnswer ? 'api/_main/Jobs/jobproceed/' + parId : 'api/_main/Jobs/jobabort/' + parId;
                // Nasconde subito i pulsanti Si'/No (lo stato non e' piu' 140) per dare
                // riscontro immediato ed evitare un secondo click, che colpirebbe il job
                // gia' ripartito generando "Job not waiting for user input".
                this.JobStatus.fkstatus = parAnswer ? 150 : 220;
                axios.get(Link, this.$store.state.Headers)
                    .then(() => {
                        // Riallinea subito la card allo stato reale del job.
                        this.GetJobStatus();
                    }).catch(e => {
                        this.errors.push(e);
                        this.GetJobStatus();
                    });
            }
            

        }
    }
</script>